import { useQuery } from "@tanstack/react-query";
import { getGithubConnectionFormData } from "../../api/apiCallManager";

// Custom hook to fetch GitHub connection form data
function useGithubConnectionFormData() {
  const { data: formData, isSuccess: isFormDataLoaded } = useQuery({
    queryKey: ["getGithubConnectionFormData"], // Include modalType in queryKey
    queryFn: () => getGithubConnectionFormData(), // Pass modalType to the API call
  });

  return { formData, isFormDataLoaded };
}

export default useGithubConnectionFormData;
